// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import LandingPage from './components/LandingPage';
import LoginView from './components/LoginView';
import CrearCredenciales from './components/CrearCredenciales';
import ResetPasswordForm from './components/ResetPasswordForm';
import BookMe from './components/BookMe';
import TermsOfService from './views/Legal/TermsOfService';
import PrivacyPolicy from './views/Legal/PrivacyPolicy';
import Support from './views/Legal/Support';
import Disclaimers from './views/Legal/Disclaimers';
import NfcProfile from './views/Public/NfcProfile';
import NfcTeamProfile from './views/Public/NfcTeamProfile';
import CampaignInterestWizard from './views/Public/CampaignInterestWizard';
import PublicQualificationWizard from './views/Public/PublicQualificationWizard';
import PublicInvoiceView from './views/Public/PublicInvoiceView';
import PublicMonthlyAgreement from './views/Public/PublicMonthlyAgreement';
import SeoLandingPage from './views/Public/SeoLandingPage';
import LandingQualificationWizard from './views/Public/LandingQualificationWizard';

import adminRoutes from './routes/adminRoutes';
import clientRoutes from './routes/clientRoutes';
import sellerRoutes from './routes/sellerRoutes';
import staffRoutes from './routes/staffRoutes';

function App() {
  return (
    <Routes>
      {/* Rutas públicas */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginView />} />
      <Route path="/crear-credenciales" element={<CrearCredenciales />} />
      <Route path="/reset-password" element={<ResetPasswordForm />} />
      <Route path="/bookme" element={<BookMe />} />
      <Route path="/terminos" element={<TermsOfService />} />
      <Route path="/eula" element={<TermsOfService />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/privacidad" element={<PrivacyPolicy />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/contact" element={<Support />} />
      <Route path="/soporte" element={<Support />} />
      <Route path="/support" element={<Support />} />
      <Route path="/disclaimers" element={<Disclaimers />} />
      <Route path="/avisos" element={<Disclaimers />} />
      <Route path="/nfc/:clientId" element={<NfcProfile />} />
      <Route path="/nfc/team/:teamId" element={<NfcTeamProfile />} />
      <Route path="/interes/:campaignId" element={<CampaignInterestWizard />} />
      <Route path="/interes/landing/:slug" element={<LandingQualificationWizard />} />
      <Route path="/calificar" element={<PublicQualificationWizard />} />
      <Route path="/factura/:clientId/:invoiceId" element={<PublicInvoiceView />} />
      <Route path="/firma/acuerdo-mensual/:token" element={<PublicMonthlyAgreement />} />
      <Route path="/soluciones/:slug" element={<SeoLandingPage />} />

      {/* Rutas cliente */}
      {clientRoutes}

      {/* Rutas admin */}
      {adminRoutes}
      {/* Rutas vendedores */}
      {sellerRoutes}
      {/* Rutas equipo */}
      {staffRoutes}

      {/* Fallback */}
      <Route path="*" element={<h2>Página no encontrada</h2>} />
    </Routes>
  );
}

export default App;
